// import { EMenuKeys } from 'core/common/constants/product-new'

export const DEFAULT_HIDDEN_STEPS = ['']
